import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/home';

const footerLinks = {
  快速导航: [
    { name: '首页', path: '/' },
    { name: '下载指南', path: '/category/download-guide' },
    { name: '使用教程', path: '/category/tutorials' },
    { name: '关于我们', path: '/about' },
  ],
  资源中心: [
    { name: '安全指南', path: '/category/security' },
    { name: '常见问题', path: '/category/faq' },
    { name: '最新动态', path: '/category/news' },
    { name: '行业资讯', path: '/category/industry' },
  ],
  下载入口: [
    { name: 'iOS 版本下载', path: siteInfo.downloadLinks.ios },
    { name: 'Android 版本下载', path: siteInfo.downloadLinks.android },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-apps-2-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-background-50">
                {siteInfo.name}
              </span>
            </div>
            <p className="text-sm text-secondary-300 leading-relaxed mb-4">
              {siteInfo.tagline}
            </p>
            <p className="text-xs text-secondary-400">
              官方认证渠道，安全正版下载<br />
              保障您的账户安全与数据隐私
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">{title}</h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.name}>
                    {link.path.startsWith('http') ? (
                      <a
                        href={link.path}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm text-secondary-300 hover:text-background-50 transition-colors cursor-pointer"
                      >
                        {link.name}
                      </a>
                    ) : (
                      <Link
                        to={link.path}
                        className="text-sm text-secondary-300 hover:text-background-50 transition-colors cursor-pointer"
                      >
                        {link.name}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-secondary-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-400">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有 | 保留一切权利
          </p>
          <div className="flex items-center gap-4">
            <a href="mailto:support@008pg.com" className="text-xs text-secondary-400 hover:text-background-50 transition-colors cursor-pointer">
              联系我们
            </a>
            <span className="text-secondary-600">|</span>
            <Link to="/about" className="text-xs text-secondary-400 hover:text-background-50 transition-colors cursor-pointer">
              关于我们
            </Link>
            <span className="text-secondary-600">|</span>
            <span className="text-xs text-secondary-400">
              7×24小时客服在线
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}